import { useCounter } from "@disco/disco_core";
import inPreview from "../utils/inPreview";
import useData from "./useData";
import { useCallback, useMemo, useState } from "react";

const useNurtureOffers = () => {
	const { brands } = useData();

	const NUM_OFFERS_IDX = inPreview
		? 0
		: Array.isArray(brands)
		? brands.length - 1
		: 0;

	const TOTAL_OFFERS = NUM_OFFERS_IDX + 1;

	const {
		counter: activeOfferIdx,
		increment: showNextOffer,
		decrement: showPrevOffer,
		setCounter,
		isMin: isFirstOffer,
		isMax: isLastOffer,
	} = useCounter({
		start: 0,
		min: 0,
		max: NUM_OFFERS_IDX,
	});

	const activeOffer = useMemo(
		() => brands[activeOfferIdx],
		[brands, activeOfferIdx]
	);

	const [claimedOffers, setClaimedOffers] = useState([]);

	const claimOffer = useCallback(() => {
		setClaimedOffers([...claimedOffers, activeOffer?.id]);
	}, [claimedOffers, activeOffer]);

	const isOfferClaimed = useMemo(
		() => activeOffer && claimedOffers.includes(activeOffer?.id),
		[activeOffer, claimedOffers]
	);

	const areOffersEmpty = useMemo(() => brands.length === 0, [brands]);

	return {
		NUM_OFFERS_IDX,
		TOTAL_OFFERS,
		areOffersEmpty,

		activeOffer,
		activeOfferIdx,
		setActiveOfferIdx: setCounter,

		claimOffer,
		claimedOffers,
		isOfferClaimed,

		isFirstOffer,
		showNextOffer,
		showPrevOffer,
		isLastOffer,
	};
};

export default useNurtureOffers;
